import React, { useState, useEffect } from "react";
import LabelValueRow from "../../LabelValueRow";
import { Switch } from "@mui/material";

// LIBERA PROFESSIONE
const LiberaProfessioneWidget = ({
  setContributiTotali,
  contributiTotali,
  redditoPrevidenziale,
  isFullTime,
}) => {
  const [checked, setChecked] = useState(false);

  const [factors] = useState({
    aliquota_base: 0.2623,
    aliquota_ridotta: 0.24,
    contributi_massimali: 105014,
  });

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
    if (isFullTime === "1") {
      setChecked(true);
    }
  }, [isFullTime, setChecked]);

  useEffect(() => {
    if (redditoPrevidenziale < factors.contributi_massimali) {
      setContributiTotali(
        redditoPrevidenziale *
          (checked === true ? factors.aliquota_ridotta : factors.aliquota_base)
      );
    } else {
      setContributiTotali(
        factors.contributi_massimali *
          (checked === true ? factors.aliquota_ridotta : factors.aliquota_base)
      );
    }
  }, [
    checked,
    redditoPrevidenziale,
    factors.contributi_massimali,
    factors.aliquota_ridotta,
    factors.aliquota_base,
    setContributiTotali,
  ]);

  return (
    <>
      {isFullTime === "1" && (
        <div className="flex flex-row justify-between items-center bg-gray-100 px-4 mb-4 pb-2 pt-2 dark:bg-gray-600 w-[100%]">
          <div className="flex flex-col text-left">
            <span className="text-gray-400">Puoi pagare meno contributi</span>
            <div className="text-sm leading-[1.2] dark:text-gray-400">
              Avendo già una posizione previdenziale attiva con il tuo lavoro
              dipendente full-time puoi ridurre l'aliquota contributiva dal{" "}
              <strong>26,23%</strong> al <strong> 24%</strong>{" "}
            </div>
          </div>
          <Switch
            color="warning"
            checked={checked}
            onChange={handleChange}
            inputProps={{ "aria-label": "controlled" }}
          />
        </div>
      )}
      <LabelValueRow
        label="Contributi totali"
        value={contributiTotali}
        important={true}
      />
    </>
  );
};

export default LiberaProfessioneWidget;
